module.exports = __webpack_public_path__ + "static/media/donorIcon.f4de0caf.png";